(function () {
  if (!document.body.classList.contains('revivol-pdp')) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function track(event, params) {
    try {
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'pdp_' + event }, params || {}));
      if (window.fbq) window.fbq('trackCustom', 'RevivolPDP_' + event, params || {});
    } catch (e) {}
  }

  /* ---------- gallery ---------- */
  var images = [];
  var currentIndex = 0;

  function readImages() {
    var node = $('[data-pdp-images]');
    if (!node) return [];
    try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
  }

  function showImage(index) {
    if (!images.length) return;
    currentIndex = (index + images.length) % images.length;
    var data = images[currentIndex];
    var main = $('#pdp-main-image');
    if (main) {
      main.src = data.src;
      main.removeAttribute('srcset');
      main.alt = data.alt || '';
    }
    $$('[data-pdp-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === currentIndex);
    });
  }

  function initGallery() {
    images = readImages();
    $$('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.getAttribute('data-index'), 10) || 0);
        track('gallery_thumb', { index: currentIndex });
      });
    });
  }

  /* ---------- lightbox ---------- */
  var lastFocused = null;

  function lightboxRender() {
    var img = $('[data-pdp-lightbox-img]');
    var counter = $('[data-pdp-lightbox-counter]');
    if (!images.length) return;
    var data = images[currentIndex];
    if (img) { img.src = data.src; img.alt = data.alt || ''; img.hidden = false; }
    if (counter) counter.textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  function openLightbox() {
    var box = $('[data-pdp-lightbox]');
    if (!box || !images.length) return;
    lastFocused = document.activeElement;
    box.hidden = false;
    document.body.classList.add('pdp-noscroll');
    lightboxRender();
    var closeBtn = $('[data-pdp-lightbox-close]', box);
    if (closeBtn) closeBtn.focus();
    track('gallery_open', { index: currentIndex });
  }

  function closeLightbox() {
    var box = $('[data-pdp-lightbox]');
    if (!box) return;
    box.hidden = true;
    document.body.classList.remove('pdp-noscroll');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function step(delta) { showImage(currentIndex + delta); lightboxRender(); }

  function initLightbox() {
    var box = $('[data-pdp-lightbox]');
    if (!box) return;
    var opener = $('[data-pdp-gallery-open]');
    if (opener) opener.addEventListener('click', openLightbox);
    $$('[data-pdp-lightbox-close]').forEach(function (el) { el.addEventListener('click', closeLightbox); });
    var prev = $('[data-pdp-lightbox-prev]');
    var next = $('[data-pdp-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'Tab') {
        // keep focus inside the dialog
        var focusables = $$('button', box).filter(function (b) { return b.offsetParent !== null; });
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- quantity ---------- */
  function initQty() {
    var input = $('[data-pdp-qty-input]');
    if (!input) return;
    function clamp() {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      input.value = n;
      return n;
    }
    var up = $('[data-pdp-qty-up]');
    var down = $('[data-pdp-qty-down]');
    if (up) up.addEventListener('click', function () { input.value = clamp() + 1; });
    if (down) down.addEventListener('click', function () { input.value = Math.max(1, clamp() - 1); });
    input.addEventListener('change', clamp);
    input.addEventListener('blur', clamp);
  }

  /* ---------- add to cart ---------- */
  function setFeedback(message, isError) {
    var el = $('[data-pdp-feedback]');
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-error', !!isError);
    el.classList.toggle('is-visible', !!message);
  }

  /* Primary button is BUY NOW: add, then go straight to checkout. The AJAX add exists only
     so the tracking events fire before we navigate away; the form also carries
     return_to=/checkout so a no-JS submit lands in the same place. If a cart-stage upsell
     is ever added, this is the function that has to stop redirecting. */
  function initAddToCart() {
    var form = $('#pdp-product-form');
    var btn = $('[data-pdp-atc]');
    if (!form || !btn) return;

    form.addEventListener('submit', function (e) {
      // Progressive enhancement: if fetch is missing, let the native form post through.
      if (!window.fetch) return;
      e.preventDefault();

      var qtyInput = $('[data-pdp-qty-input]');
      var variantInput = $('[data-pdp-variant-id]');
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var variantId = variantInput && variantInput.value;
      if (!variantId) return;

      var label = $('.pdp-atc__label', btn);
      var originalLabel = label ? label.textContent : '';
      if (label) label.textContent = 'One moment...';
      btn.disabled = true;
      setFeedback('');

      track('atc_attempt', { qty: qty, variant: variantId });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          if (label) label.textContent = 'Taking you to checkout...';
          track('atc_success', { qty: qty, variant: variantId, flow: 'buy_now' });
          // Button stays disabled through navigation so a double tap can't add twice.
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[RevivolPDP] add to cart failed', err);
          if (label) label.textContent = originalLabel;
          btn.disabled = false;
          setFeedback((err && err.message) || 'Sorry, we had trouble starting checkout. Please try again.', true);
          track('atc_error', { message: err && err.message });
        });
    });
  }

  /* ---------- outbound + generic tracking ---------- */
  function initTracking() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pdp-track]');
      if (!t) return;
      track(t.getAttribute('data-pdp-track'), {
        handle: t.getAttribute('data-handle') || undefined,
        asin: t.getAttribute('data-asin') || undefined
      });
    });
  }

  /* ---------- header offset ----------
     The theme header is sticky and overlaps the top of the template. CSS alone can't know its
     height, so measure the real element and publish it as a custom property. */
  function syncHeaderOffset() {
    var header = document.querySelector(
      '#shopify-section-new_header, #shopify-section-header, .site-header, header[role="banner"], header'
    );
    if (!header) return;

    // This theme's header wrapper measures 0px tall because .new-header inside it is taken out
    // of flow, so the wrapper's own height tells us nothing. Measure the painted bottom of its
    // visible children instead, skipping off-canvas drawers parked outside the viewport.
    var vw = window.innerWidth;
    var bottom = 0;
    var nodes = header.querySelectorAll('*');
    Array.prototype.forEach.call(nodes, function (el) {
      var c = window.getComputedStyle(el);
      if (c.display === 'none' || c.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height === 0) return;
      if (r.right <= 0 || r.left >= vw) return; // off-canvas menu
      if (r.top > 300) return;                  // not part of the header band
      if (r.bottom > bottom) bottom = r.bottom;
    });

    // Only offset when the header genuinely overlays content, i.e. it reserves no flow space.
    var wrapperHeight = header.getBoundingClientRect().height;
    var overlays = wrapperHeight < bottom - 4;
    var offset = overlays ? Math.round(bottom - window.scrollY) : 0;
    if (offset > 0 && offset < 400) {
      document.body.style.setProperty('--pdp-header-offset', offset + 'px');
    }
  }

  function boot() {
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset, { passive: true });
    initGallery();
    initLightbox();
    initQty();
    initAddToCart();
    initTracking();
    track('page_view');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
